<template lang="pug">
  v-row(no-gutters)
    v-col(cols=12) 
      h3.white--text.font-weight-power-ball STEP 2: POWER BALL ({{ $t('power-ball.select-amount-power-ball') }})
    v-col(
      v-for='(item,i) in numberItems'
      :key='i'
      style="max-width:10%; flex: 0 0 10%"
      align="center"
    ) 
      v-btn-toggle.d-block.ma-1(
        :value="selectAmount"
        style="border-radius:11px;"
        color='var(--btn-activate-powerball-v2)'
      ).buttonStake
        v-btn(
          block
          :value="item"
          color="white"
          style="padding:0; border-width:inherit; height:100%;"
          @click.preven="clickValue(item)"
        )
          h3 {{ item }}
</template>
<script>
export default {
  props: {
    value: {
      type: Number,
      default: null
    }, 
  },
  data: () => ({
    selectAmount:null,
  }),
  computed: {
    numberItems () {
      return 35
    },
  },
  watch: {
    selectAmount (val) {
      this.$emit('input', val)
    },
    value (val) { 
      this.selectAmount = val
    },
  },
  mounted () {
    this.selectAmount = this.value
  },
  methods: {
    clear () {
      setTimeout(()=>{
        this.selectAmount = 0 
        this.selectAmount = null 
      },100) 
    },
    clickValue (val) {
      if(this.selectAmount === val) {
        this.selectAmount = null
        return
      } 
      this.selectAmount = val
    },
  }
}
</script>
<style lang="scss" scoped>
@media only screen and (max-width: 960px) {
  h3{
    font-size: 0.8rem;
  }
}

@media only screen and (max-width: 1260px) {
  .buttonStake {
    width: min(7vw ,100px);
    height: min(7vw ,100px);
  }
}
@media only screen and (min-width: 1261px) {
  .buttonStake {
    width: min(4vw ,60px);
    height: min(4vw ,60px);
  }
}
</style>